/**
 * Reset CSS et styles de base pour le widget Ringado
 */
export const RESET_STYLES = `
  /* Reset et base */
  .ringado-widget * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .ringado-widget {
    position: fixed;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
  }
`;
